/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

import $ from 'jquery';
import { isInGeotarget } from 'src/scripts/utils/location';
import { ShippingCountryState } from 'src/scripts/utils/shipping';
import '../../../styles/templates/customers/account.scss';
import { handleAuthForm } from 'src/scripts/global';

const selectors = {
  recoverPasswordForm: '#RecoverPassword',
  hideRecoverPasswordLink: '#HideRecoverPasswordLink',
};

//@ts-expect-error // ? [REVISIT]
function onShowHidePasswordForm(evt) {
  evt.preventDefault();
  toggleRecoverPasswordForm();
}

function checkUrlHash() {
  const { hash } = window.location;

  // Allow deep linking to recover password form
  if (hash === '#recover') {
    toggleRecoverPasswordForm();
  }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
  $('#RecoverPasswordForm').toggleClass('d-none center-block');
  $('#CustomerLoginForm').toggleClass('d-none');
  $('.create-customer').toggleClass('d-none');
  $('.social-login').toggleClass('d-none');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
  const $formState = $('.reset-password-success');

  // check if reset password form was successfully submited.
  if (!$formState.length) {
    return;
  }

  // show success message
  $('#ResetSuccess').removeClass('hide');
}

if ($(selectors.recoverPasswordForm).length) {
  checkUrlHash();
  resetPasswordSuccess();

  $(selectors.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(selectors.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);
}

(async () => {
  const isInUSgeo = await isInGeotarget({ countries: ['US'] });
  const isInUS = ShippingCountryState.countryCode ? ShippingCountryState.countryCode === 'US' : isInUSgeo;
  if (!isInUS) {
    const phoneNumberGroup = document.querySelector('.phone-number-domestic');
    phoneNumberGroup?.remove();
  }
})();

handleAuthForm('/account', 'Login or Register Page');
